var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout_Master',[_c('main',{staticClass:"content"},[(_vm.statusIsLoading)?[_c('Spinner',{staticClass:"orange center-absolute"})]:(_vm.statusIsReady)?[_c('Notifications_List',{attrs:{"notifications":_vm.getNotifications}})]:_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }